var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3985 20.7855C66.9692 14.7194 56.8033 17.504 49.5935 23.4921L47.4544 11.6625C47.0367 9.35259 44.823 7.81692 42.5132 8.2346C40.2033 8.65228 38.6676 10.8659 39.0853 13.1758L40.8574 22.9759C39.4098 20.6579 37.5008 18.2979 34.9364 16.5188C27.5246 11.377 17.4061 12.7746 17.4061 12.7746C17.4061 12.7746 19.0121 19.6965 23.8355 24.9822C12.4226 29.1634 5.24505 41.1134 7.47797 53.462C12.7746 82.7536 40.0715 95.103 49.2775 93.4384C52.2067 92.9087 54.9845 91.5421 57.1925 89.4143C59.9302 90.2157 63.0864 90.9414 66.0156 90.4117C75.2215 88.747 95.705 63.4407 91.1692 38.3328C89.82 30.8718 85.0956 24.3409 78.3985 20.7855Z",
    fill: "#D2EEE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiet);
export default __webpack_public_path__ + "static/media/diet.6bc0622a.svg";
export { ForwardRef as ReactComponent };